import Routes from './routes'

import Config from './config'

export default {
  Routes,
  Config,
}
